import ProFeatureDialog from '@/components/ProFeatureDialog';
import type { QuotaLimitKind } from '@/lib/quota/classifyQuotaError';
import { useTranslation } from 'react-i18next';

interface Props {
  kind: QuotaLimitKind | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onUpgrade: () => void;
}

const QuotaUpsellDialog = ({ kind, open, onOpenChange, onUpgrade }: Props) => {
  const { t } = useTranslation();
  if (!kind) return null;

  return (
    <ProFeatureDialog
      open={open}
      onOpenChange={onOpenChange}
      onUpgrade={onUpgrade}
      title={t(`quotaUpsell.${kind}.title`)}
      body={t(`quotaUpsell.${kind}.body`)}
      dismissLabel={t('quotaUpsell.dismiss')}
      upgradeLabel={t('quotaUpsell.upgrade')}
      testIdPrefix={`quota-upsell-${kind}`}
    />
  );
};

export default QuotaUpsellDialog;
